import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const ADMIN_ROUTES: Routes = [
  {
    path: 'comittee/member-list',
    loadComponent: () => import('./comittee/comittee-member-list/comittee-member-list.component').then(m => m.ComitteeMemberListComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'comittee/member-list/:year',
    loadComponent: () => import('./comittee/comittee-member-list/comittee-member-list.component').then(m => m.ComitteeMemberListComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'club-seasons',
    loadComponent: () => import('../clubs/club-season-admin/club-season-admin.component').then(m => m.ClubSeasonAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'clubs/:seasonId',
    loadComponent: () => import('../clubs/club-admin/club-admin.component').then(m => m.ClubAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'import-clubs',
    loadComponent: () => import('../clubs/club-data-import/club-data-import.component').then(m => m.ClubDataImportComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'shelter-employee-proxy',
    loadComponent: () => import('./shelter-employee-proxy-admin/shelter-employee-proxy-admin.component').then(m => m.ShelterEmployeeProxyAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  }
];
